/* eslint-disable no-restricted-globals -- this is the abstraction for localStorage */
import type { StorageAdapter } from '../storage.types';

/**
 * Creates a localStorage adapter
 */
export const createLocalStorageAdapter = (): StorageAdapter => ({
  getItem: async (key) => localStorage.getItem(key),
  removeItem: async (key) => localStorage.removeItem(key),
  setItem: async (key, value) => localStorage.setItem(key, value),
});
